import BaseView from '../views/BaseView';
import RelatedStory from '../components/RelatedStory';
import CRelatedStoryCarousel from '../components/CRelatedStoryCarousel';
import { scrollPageTo } from '../utils';

export default class AudioStory extends BaseView {
	constructor(container) {
		super(container);
		this.breakpoint = window.matchMedia('(max-width:575px)');
		this.pauseTimer = null;
	}

	init() {
		const groups = new Map([
			[RelatedStory, this.container.querySelectorAll('[data-related-story]')],
			[CRelatedStoryCarousel, this.container.querySelectorAll('[data-c-related-story-carousel]')],
		]);

		super.createModules(groups);

		if (window.location.hash) {
			let scrollTarget = document.querySelector(window.location.hash + '-item');
			setTimeout(function () {
				scrollPageTo(scrollTarget, 1000);
			}, 400);
		}
	}
}
